var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"popup-overlay",on:{"click":_vm.close}},[_c('div',{staticClass:"popup-content",on:{"click":function($event){$event.stopPropagation();}}},[_c('iframe',{staticStyle:{"width":"100%"},attrs:{"src":_vm.videoUrl,"frameborder":"0","allowfullscreen":""}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }